(function () {
  var GAP = 2;

  function slidesPerView() {
    return window.innerWidth >= 990 ? 3 : 2;
  }

  function updateNav(slider, viewport, perView, total) {
    var prev = slider.querySelector('.hajink-chiko-slider__nav--prev');
    var next = slider.querySelector('.hajink-chiko-slider__nav--next');
    if (!prev || !next) return;

    var maxIndex = Math.max(0, total - perView);
    var index = slider._hajinkSlideIndex || 0;

    prev.classList.toggle('is-disabled', index <= 0);
    next.classList.toggle('is-disabled', index >= maxIndex || total <= perView);
  }

  function layoutSlider(slider) {
    var viewport = slider.querySelector('.hajink-chiko-slider__viewport');
    var items = slider.querySelectorAll('.hajink-chiko-slider__item');
    if (!viewport || !items.length) return 0;

    var perView = slidesPerView();
    var gaps = GAP * (perView - 1);
    var slideWidth = (viewport.clientWidth - gaps) / perView;

    items.forEach(function (item) {
      item.style.flex = '0 0 ' + slideWidth + 'px';
      item.style.width = slideWidth + 'px';
      item.style.maxWidth = slideWidth + 'px';
    });

    return slideWidth + GAP;
  }

  function bindSlider(slider) {
    var viewport = slider.querySelector('.hajink-chiko-slider__viewport');
    var prev = slider.querySelector('.hajink-chiko-slider__nav--prev');
    var next = slider.querySelector('.hajink-chiko-slider__nav--next');
    if (!viewport || !prev || !next) return;

    if (slider.dataset.hajinkSliderBound !== 'true') {
      slider.dataset.hajinkSliderBound = 'true';
      slider._hajinkSlideIndex = 0;

      prev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var perView = slidesPerView();
        var step = layoutSlider(slider);
        var items = slider.querySelectorAll('.hajink-chiko-slider__item');
        slider._hajinkSlideIndex = Math.max(0, (slider._hajinkSlideIndex || 0) - 1);
        viewport.scrollTo({ left: slider._hajinkSlideIndex * step, behavior: 'smooth' });
        updateNav(slider, viewport, perView, items.length);
      });

      next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var perView = slidesPerView();
        var step = layoutSlider(slider);
        var items = slider.querySelectorAll('.hajink-chiko-slider__item');
        var maxIndex = Math.max(0, items.length - perView);
        slider._hajinkSlideIndex = Math.min(maxIndex, (slider._hajinkSlideIndex || 0) + 1);
        viewport.scrollTo({ left: slider._hajinkSlideIndex * step, behavior: 'smooth' });
        updateNav(slider, viewport, perView, items.length);
      });

      viewport.addEventListener('scroll', function () {
        var perView = slidesPerView();
        var step = layoutSlider(slider) || 1;
        var items = slider.querySelectorAll('.hajink-chiko-slider__item');
        slider._hajinkSlideIndex = Math.round(viewport.scrollLeft / step);
        updateNav(slider, viewport, perView, items.length);
      }, { passive: true });

      window.addEventListener('resize', function () {
        var perView = slidesPerView();
        var step = layoutSlider(slider);
        var items = slider.querySelectorAll('.hajink-chiko-slider__item');
        var maxIndex = Math.max(0, items.length - perView);
        if ((slider._hajinkSlideIndex || 0) > maxIndex) slider._hajinkSlideIndex = maxIndex;
        viewport.scrollLeft = (slider._hajinkSlideIndex || 0) * step;
        updateNav(slider, viewport, perView, items.length);
      });

      if (typeof ResizeObserver !== 'undefined') {
        var observer = new ResizeObserver(function () {
          var perView = slidesPerView();
          var step = layoutSlider(slider);
          var items = slider.querySelectorAll('.hajink-chiko-slider__item');
          viewport.scrollLeft = (slider._hajinkSlideIndex || 0) * step;
          updateNav(slider, viewport, perView, items.length);
        });
        observer.observe(viewport);
      }
    }

    var perView = slidesPerView();
    var step = layoutSlider(slider);
    var items = slider.querySelectorAll('.hajink-chiko-slider__item');
    viewport.scrollLeft = (slider._hajinkSlideIndex || 0) * step;
    updateNav(slider, viewport, perView, items.length);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-hajink-chiko-slider]').forEach(bindSlider);
  }

  window.HajinkChikoSlider = {
    init: initAll,
    refresh: function (slider) {
      if (!slider) return;
      bindSlider(slider);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
})();
